import { cdnPath } from '@shared/domain/utils/remoteUrl'

const addScript = (src) => {
  return new Promise((resolve, reject) => {
    let shouldAppend = false
    let el = document.querySelector('script[src="' + src + '"]')
    if (!el) {
      el = document.createElement('script')
      el.type = 'text/javascript'
      el.async = true
      el.src = src
      shouldAppend = true
    } else if (el.hasAttribute('data-loaded')) {
      resolve(el)
      return
    }

    el.addEventListener('error', reject)
    el.addEventListener('abort', reject)
    el.addEventListener('load', () => {
      el.setAttribute('data-loaded', true)
      resolve(el)
    })

    if (shouldAppend) {
      document.head.appendChild(el)
    }
  })
}

const interactionEvents = ['mousemove', 'scroll', 'keydown', 'click', 'touchstart', 'wheel']
let alreadyAdded = false

const initHydration = () => {
  if (alreadyAdded) {
    return
  }
  alreadyAdded = true
  interactionEvents.forEach((event) => window.removeEventListener(event, initHydration))
  addScript(cdnPath('/shell/client/main.js')).catch((err) => console.error('Hydration: failed to load', err))
}

interactionEvents.forEach((event) => window.addEventListener(event, initHydration, { once: true }))
setTimeout(initHydration, window?._delayedHydration || 6000)
